import i18n from 'i18next';
import { initReactI18next } from 'react-i18next/dist/es';

export function initI18n(translation, commondata, configuration) {
    i18n.use(initReactI18next) // passes i18n down to react-i18next
        .init({
            resources: {
                sv: {
                    translation: { ...translation, ...commondata, ...configuration }
                }
            },
            lng: 'sv',

            keySeparator: false, // we do not use keys in form messages.welcome

            interpolation: {
                escapeValue: false // react already safes from xss
            }
        });
}
